import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Facebook, Clock } from 'lucide-react';
import MadBrothersLogo from './MadBrothersLogo';

export const Footer = () => {
  const quickLinks = [
    { name: 'Shop', path: '/shop' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Allergen Guide', path: '/allergens' },
    { name: 'Cake Care Tips', path: '/cake-care' },
  ];

  return (
    <footer className="bg-[#1C1917] text-white relative grain-overlay" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <MadBrothersLogo size="md" variant="light" />
            <p className="text-stone-400 text-sm leading-relaxed">
              With over 30 years of family baking tradition behind us, we combine time-honoured recipes with modern creativity to craft truly artisan products — now freshly made and proudly served in the heart of Dublin 7 since 2021.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/madbrothers.bakery/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#8D6E63] transition-colors"
                data-testid="instagram-link"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#8D6E63] transition-colors"
                data-testid="facebook-link"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-stone-400 hover:text-white transition-colors text-sm"
                    data-testid={`footer-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm">
                <MapPin className="w-5 h-5 text-[#8D6E63] flex-shrink-0 mt-0.5" />
                <span className="text-stone-400">
                  17 Nephin Road, Ashtown,<br />
                  Dublin 7, D07 N8K7
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail className="w-5 h-5 text-[#8D6E63] flex-shrink-0" />
                <a href="mailto:madbrotherscakes@gmail.com" className="text-stone-400 hover:text-white transition-colors">
                  madbrotherscakes@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Clock className="w-5 h-5 text-[#8D6E63] flex-shrink-0" />
                <span className="text-stone-400">
                  Mon-Fri: 8am - 4pm<br />
                  Sat: 8:30am - 4pm<br />
                  Sun: 9am - 4pm
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            © {new Date().getFullYear()} Mad Brothers Bakery. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-stone-500">
            <Link to="/allergens" className="hover:text-white transition-colors">Allergen Info</Link>
            <Link to="/cake-care" className="hover:text-white transition-colors">Cake Care</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
